<template>

</template>
<script>

  import {createObjectByEval} from '@/utils/commonUtils'
  import {isEqual, merge} from 'lodash'

  export default {
    name: "entities-czml-data-source",
    props: {
      cesiumId: {
        type: String,
        default: "default"
      },
      czmlDataSourcesId: {
        type: String,
        default: "default"
      },
      maxDiffTimeForUpdate: {
        type: Number,
        default: -1
      },
      czmlParamsPromiseFun: {
        type: Function,
        default: () => Promise.resolve({position: [], duration: undefined, startTime: undefined, step: undefined})
      },
      entities: {//объект должен быть иммутабелен
        type: Array,
        default: () => []
      },
      entityCzmlTemplate: {
        type: Object | Array,
        default: () => {
          return {}
        }
      }
    },
    data: () => {
      return {
        lastTimeUpdate: undefined
      }
    },
    methods: {
      updateCzmlForEntities(entities, czmlDataSource) {
        const self = this;

        const currentTime = Cesium.JulianDate.toDate(window.cesiumViewer[this.cesiumId].viewer.cesiumWidget.clock.currentTime).getTime();

        this.lastTimeUpdate = currentTime;

        const asyncRequests = [];//TODO продумать cancel

        entities.forEach(entity => {
          const asyncRequest = self.czmlParamsPromiseFun(entity, currentTime);
          asyncRequests.push(asyncRequest);

          asyncRequest.then(czmlParams => {
            if (Array.isArray(this.entityCzmlTemplate))
              this.entityCzmlTemplate.forEach(template => addCzmlEntity(template));
            else addCzmlEntity(this.entityCzmlTemplate);

            function addCzmlEntity(entityCzmlTemplate) {
              const czml = createObjectByEval(entityCzmlTemplate, merge({
                vue: self,
                entity,
                currentTime
              }, czmlParams));

              czmlDataSource.process(czml, {})
            }

          })
        })
      },
      clockTickHandler(c) {
        const currentTime = Cesium.JulianDate.toDate(c.currentTime).getTime();
        if (this.maxDiffTimeForUpdate !== -1 && Math.abs(currentTime - this.lastTimeUpdate) > this.maxDiffTimeForUpdate) {
          const czmlDataSource = window.cesiumViewer[this.cesiumId].getCzmlDataSource(this.czmlDataSourcesId);
          this.updateCzmlForEntities(this.entities, czmlDataSource)
        }
      },
    },
    watch: {
      entities: {//Должен быть иммутебельный
        immediate: true,
        handler(newEntities, oldEntities) {

          const entitiesForAdd = newEntities.filter(newEntity => !oldEntities.find(oldEntity => isEqual(newEntity, oldEntity)));
          const entitiesForRemove = (oldEntities || []).filter(oldEntity => !newEntities.find(newEntity => newEntity.id == oldEntity.id));

          const czmlDataSource = window.cesiumViewer[this.cesiumId].getCzmlDataSource(this.czmlDataSourcesId);

          const entityIdTemplates = Array.isArray(this.entityCzmlTemplate) ? this.entityCzmlTemplate.map(entityCzmlTemplate => entityCzmlTemplate.id) : [this.entityCzmlTemplate.id];

          entityIdTemplates.forEach(entityIdTemplate =>
            czmlDataSource.process(entitiesForRemove.map(entity => {
              return {id: createObjectByEval(entityIdTemplate, merge({vue: this, entity})), delete: true}
            }), {}));

          this.updateCzmlForEntities(entitiesForAdd, czmlDataSource)

        }
      },
      cesiumId(newCesiumId) {
        throw new Error("Deny change cesiumId");
      }
    },
    created() {
      const clock = window.cesiumViewer[this.cesiumId].viewer.cesiumWidget.clock;
      clock.onTick.addEventListener(this.clockTickHandler);
    },
    destroyed() {
      const clock = window.cesiumViewer[this.cesiumId].viewer.cesiumWidget.clock;
      clock.onTick.removeEventListener(this.clockTickHandler);
    }
  }
</script>

<style scoped>

</style>
